import React from 'react'

import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react'
import { Menu as MenuIcon } from 'src/components/icon'
import { useOpenPullDown } from 'src/hooks/use-open-pull-down'
import { useBreadcrumb } from 'src/hooks/useBreadcrumb'

import { IcfDocumentForList } from '../../icf-document/entity'
import { SortableMultiSelectRenewal } from '../components/sortable-multi-select-renewal'
import { CreateIcfDocumentSetItem } from '../entity'
import { IcfDocumentSetErrors } from '../validate'

type Props = {
  createIcfDocumentSetItem: CreateIcfDocumentSetItem
  approvedIcfDocuments: IcfDocumentForList[] | undefined
  listPath: string
  onChangeName: (value: string) => void
  onChangeSelectedDocuments: (
    items: CreateIcfDocumentSetItem['icfDocuments'],
  ) => void
  canSubmit: boolean
  onSubmit: () => Promise<void>
  pullDownState: ReturnType<typeof useOpenPullDown>
  onCancel: () => void
  errors: IcfDocumentSetErrors
}

export const AddIcfDocumentSetRenewal: React.FC<Props> = ({
  createIcfDocumentSetItem,
  approvedIcfDocuments,
  listPath,
  onChangeName,
  onChangeSelectedDocuments,
  canSubmit,
  onSubmit,
  onCancel,
  errors,
}) => {
  const { renderBreadcrumb } = useBreadcrumb()

  return (
    <Flex h="full" direction="column" py="6">
      <Flex justify="space-between" wrap="wrap" rowGap="2" px="6">
        {renderBreadcrumb([
          {
            text: '文書セット一覧',
            link: listPath,
          },
          {
            text: '文書セット登録',
            isCurrentPage: true,
          },
        ])}
        <Flex flex="1" justify="end">
          <HStack>
            <Button onClick={onSubmit} isDisabled={!canSubmit}>
              登録
            </Button>
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<MenuIcon />}
                variant="customIconButtonGhost"
              />
              <MenuList>
                <MenuItem color="red.500" onClick={onCancel}>
                  キャンセル
                </MenuItem>
              </MenuList>
            </Menu>
          </HStack>
        </Flex>
      </Flex>
      <Box flex="1" mt="8" pt="4" px="6">
        <FormControl isInvalid={!!errors.name}>
          <FormLabel>文書セット名</FormLabel>
          <Input
            maxWidth="400px"
            value={createIcfDocumentSetItem.name}
            onChange={e => onChangeName(e.target.value)}
          />
          <FormErrorMessage>{errors.name && errors.name}</FormErrorMessage>
        </FormControl>
        <Box mt="8">
          {approvedIcfDocuments !== undefined && (
            <SortableMultiSelectRenewal
              icfDocuments={approvedIcfDocuments}
              onChangeSelectedDocuments={onChangeSelectedDocuments}
              selectedIcfDocuments={createIcfDocumentSetItem.icfDocuments}
              errorMessage={errors.documents}
            />
          )}
        </Box>
      </Box>
    </Flex>
  )
}
